export default {
  agreementAttachments: [],
  agreementAttachment: undefined,
};
